<template>
  <table class="w-full">
    <tbody v-auto-animate>
      <tr class="text-sm">
        <!-- <th class="indicator"></th> -->
        <th class="w-8">#</th>
        <th class="text-left">Team</th>
        <th class="w-8">G</th>
        <th class="w-8">W</th>
        <th class="w-8">D</th>
        <th class="w-8">L</th>
        <th class="w-14">DIFF</th>
        <th class="w-8 md:w-10">PTS</th>
      </tr>
      <tr v-for="row in orderedRows" :key="row.team.id" class="even:bg-slate-100 duration-300" :class="{ '!bg-slate-300': team.slug === row.team.slug }">
        <!-- <td class="indicator">
          <div class="w-1 h-5 rounded-sm" :class="{ 'bg-green-400': 1 === row[side]?.position, 'bg-green-600': [2, 3].includes(row[side]?.position), 'bg-red-400': lastPos-2 === row[side]?.position, 'bg-red-600': [lastPos-1, lastPos].includes(row[side]?.position) }" v-if="[1, 2, 3, lastPos-2, lastPos-1, lastPos].includes(row[side]?.position)"></div>
        </td> -->
        <td class="font-bold md:text-lg text-center">{{ row[side]?.position }}</td>
        <td class="md:text-lg py-1">
          <div v-if="!row.team?.slug">{{ row.team?.name }} (missing slug)</div>
          <NuxtLink class="flex gap-1.5 items-center" :to="{ name: 'team-table', params: { team: row.team.slug }}" v-else>
            <TeamLogo
                class="min-w-8 w-8 h-8 rounded-md overflow-hidden"
                :name="row.team.name"
                :slug="row.team.slug"
                :logo="row.team.logo"
                size="64"
                :alt="row.team.abbr"
              />
              <div class="line-clamp-1 font-bold md:hidden">{{ row.team.abbr }}</div>
            <div class="line-clamp-1 font-bold max-md:hidden">{{ row.team.name }}</div>
          </NuxtLink>
        </td>
        <td class="text-center">{{ row[side]?.games }}</td>
        <td class="text-center">{{ row[side]?.win }}</td>
        <td class="text-center">{{ row[side]?.draw }}</td>
        <td class="text-center">{{ row[side]?.loss }}</td>
        <td class="text-center">{{ [row[side]?.goalsFor, row[side]?.goalsAgainst].join(':') }}</td>
        <td class="md:text-lg text-center font-bold">
          {{ row[side]?.points }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
const team = useTeamStore()

const props = defineProps({
  rows: {
    type: Array,
    default: () => []
  },
  side: {
    type: String,
    default: 'total'
  }
})

// Total teams
const lastPos = props.rows.length

// Order rows by total position 
const orderedRows = computed(() => {
  const rows = [...props.rows]

  if (props.side === 'home') {
    return rows?.sort((a, b) => a.home.position - b.home.position)
  }

  if (props.side === 'away') {
    return rows?.sort((a, b) => a.away.position - b.away.position)
  }

  return rows?.sort((a, b) => a.total.position - b.total.position)
})
</script>

<style scoped>
table th {
  @apply font-normal text-slate-500 uppercase pb-2;
}

/*
table {
  th {
    @apply pb-2;
    @apply font-normal text-xs text-slate-500 uppercase;
  }

  tr.is-active {
    @apply bg-slate-300/50;

    td.team {
      @apply font-bold;
    }
  }

  th,
  td {
    &.team {
      @apply text-left;
    }

    &.position,
    &.games,
    &.win,
    &.draw,
    &.loss,
    &.diff,
    &.points {
      @apply text-center;
    }
  }

  td.team {
    @apply text-sm py-1;

    tr.is-active & {
      @apply font-bold;
    }
  }

  td {
    &.indicator {
      @apply w-0.5;
    }

    &.position {
      @apply w-6 font-bold text-sm;
    }

    &.games,
    &.win,
    &.draw,
    &.loss {
      @apply w-12;
      @apply text-sm;
    }

    &.diff {
      @apply w-14;
      @apply text-sm;
    }

    &.points {
      @apply w-12;
      @apply text-sm font-bold;
    }
  }
}
*/
</style>
